// extracted by mini-css-extract-plugin
export default {"secondary-column-cell":"secondary-column-cell_VcizF","secondaryColumnCell":"secondary-column-cell_VcizF","name":"name_a6s04"};